import { LabelUtils } from '@spotify/confidence-core-react';

export const LOCK_MODE_KEY = 'lockMode' as const;
export type LockModeValue = 'on' | 'off';

type Labels = { key: string; value?: string | null }[];

export function isLockModeOn(labels: Labels): boolean {
  return LabelUtils.getLabelValue(labels, LOCK_MODE_KEY) === 'on';
}
